import {useEffect, useState} from 'react';
import {acsIntegrationClient} from 'src/apis/acsIntegrationClient';

export function isPdkLicenseQuotaError(message?: string | null, code?: string | null) {
  if (code === 'LICENSE_QUOTA') return true;
  if (!message) return false;
  return /insufficient\s+.+\s+license quota/i.test(message);
}

export function usePdkAutoSyncStatus() {
  const [state, setState] = useState({
    locked: false,
    webhookLastError: null as string | null,
    licenseBlocked: false,
  });

  useEffect(() => {
    let cancelled = false;
    acsIntegrationClient
      .listIntegrations()
      .then(res => {
        if (cancelled) return;
        const rows = res.data?.data || [];
        const pdk = rows.find(r => r.provider === 'PDK');
        const cfg = pdk?.configJson;
        setState({
          locked: Boolean(cfg?.holderAutoSyncEnabled),
          webhookLastError: cfg?.webhookLastError || null,
          licenseBlocked:
            Boolean(cfg?.holderAutoSyncLicenseBlocked) ||
            isPdkLicenseQuotaError(cfg?.webhookLastError, cfg?.webhookLastErrorCode),
        });
      })
      .catch(() => {
        if (!cancelled) {
          setState({locked: false, webhookLastError: null, licenseBlocked: false});
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}

/** True when PDK holder auto-sync is on for this org — residents are PDK-managed. */
export function usePdkResidentLock() {
  return usePdkAutoSyncStatus().locked;
}
